import React from 'react'
import {
    Input,
    Button,
    FormItem,
    FormContainer,
    Alert,
    InputPhone,
} from 'components/ui'
import useTimeOutMessage from 'utils/hooks/useTimeOutMessage'
import { Field, Form, Formik } from 'formik'
import * as Yup from 'yup'
import useAuth from 'utils/hooks/useAuth'

const validationSchema = Yup.object().shape({
    phoneNumber: Yup.string().required(
        'Veuillez saisir votre numéro de téléphone'
    ),
    code: Yup.string()
        .required("Veuillez saisir votre code patient")
        .matches(/^[0-9]+$/, 'Le code doit contenir uniquement des chiffres'),
})

const PatientLogin = () => {
    const [message, setMessage] = useTimeOutMessage()
    const { signInPatient } = useAuth()

    const onSignIn = async (values, setSubmitting) => {
        const { phoneNumber, code } = values
        setSubmitting(true)

        const result = await signInPatient({
            phoneNumber,
            loginCode: code,
        })

        if (result.status === 'failed') {
            setMessage(result.message)
        }

        setSubmitting(false)
    }

    return (
        <div className="min-h-screen flex flex-col items-center justify-center">
            <div className="w-full max-w-md">
                <div className="mb-8 text-center">
                    <h3 className="mb-1">Espace Patient</h3>
                    <p>Veuillez saisir votre code pour accéder à votre espace</p>
                </div>
                {message && (
                    <Alert className="mb-4" type="danger" showIcon>
                        {message}
                    </Alert>
                )}
                <Formik
                    initialValues={{ phoneNumber: '', code: '' }}
                    validationSchema={validationSchema}
                    onSubmit={(values, { setSubmitting }) => {
                        onSignIn(values, setSubmitting)
                    }}
                >
                    {({ touched, errors, isSubmitting, values, setFieldValue }) => (
                        <Form>
                            <FormContainer>
                                <FormItem
                                    label="Numéro de téléphone"
                                    invalid={errors.phoneNumber && touched.phoneNumber}
                                    errorMessage={errors.phoneNumber}
                                >
                                    <InputPhone
                                        value={values.phoneNumber}
                                        name="phoneNumber"
                                        placeholder="Veuillez saisir un numéro de téléphone"
                                        handleChange={(value) => {
                                            setFieldValue('phoneNumber', value)
                                        }}
                                    />
                                </FormItem>
                                <FormItem
                                    label="Code"
                                    invalid={errors.code && touched.code}
                                    errorMessage={errors.code}
                                >
                                    <Field
                                        type="text"
                                        autoComplete="off"
                                        name="code"
                                        placeholder="Entrez votre code"
                                        component={Input}
                                    />
                                </FormItem>
                                <Button block loading={isSubmitting} variant="solid" type="submit">
                                    {isSubmitting ? 'Connexion en cours...' : 'Se connecter'}
                                </Button>
                            </FormContainer>
                        </Form>
                    )}
                </Formik>
            </div>
        </div>
    )
}

export default PatientLogin

